export const PROMO_TYPE = {
  ORDER_LEVEL: 'order',
  USER_LEVEL: 'user',
};

export const PROMO_TABS = [
  {
    key: PROMO_TYPE.ORDER_LEVEL,
    label: 'Order Level',
  },
  {
    key: PROMO_TYPE.USER_LEVEL,
    label: 'User Level',
  },
];

export const USER_ID_TYPE_OPTIONS = {
  cart_id: 'Cart ID',
  order_id: 'Order ID',
};
